export default {"src":"/_next/static/media/crunchbase.fd5aa35a.svg","height":17,"width":115};